import {
  OrderErrorTableReport
} from "../../../Interfaces/orderInterfaces";
import TableTemplate from "../../TableTemplate/tableTemplate";
import ErrorsTableUI from "./ErrorsTableUI";
import { ISearchParameters, Report } from "../../../Interfaces/TableInterfaces";

interface IErrorsTableProps<T> {
  getData: (
    searchParameters: T,
    offset: number | null,
    pageSize: number | null
  ) => Promise<Report<OrderErrorTableReport>>;
  searchParams: T;
  onFetchComplete?: (page?: number) => void;
  refreshFlag?: boolean;
  tableBoxClassName?: string;
}

const ErrorsTable = <T extends ISearchParameters>({
  getData,
  searchParams,
  onFetchComplete,
  refreshFlag,
  tableBoxClassName = "!max-h-[300px]",
}: IErrorsTableProps<T>) => {
  return (
    <div className="order-table w-full">
      <TableTemplate<T, OrderErrorTableReport>
        getDataTable={getData}
        TableUI={({ reports, onAction }) => (
          <ErrorsTableUI
            reports={reports}
            onAction={onAction}
            tableBoxClassName={tableBoxClassName}
            refreshFlag={refreshFlag}
          />
        )}
        searchParameters={searchParams}
        onFetchComplete={onFetchComplete}
      />
    </div>
  );
};

export default ErrorsTable;
